export default "__VITE_ASSET__DH0_9Feb__"